export const PROCEEDING_TYPES = Object.freeze({
    NO_REPRINT: 10,
    ADJUSTMENT: 20,
    REPRINT: 30,
})

export const ACTION_TYPES = Object.freeze({
    CREATE: 'create',
    EDIT: 'edit'
})

export const STATUSES = Object.freeze({
    NEW: 1,
    IN_PROGRESS: 2,
    ACCEPTED: 4,
    REJECTED: 5
})

export const PAGE_TITLES = Object.freeze({
    CREATE: 'Reklamacje / Nowa Reklamacja Wewnętrzna',
    EDIT: 'Reklamacje / Edycja Reklamacji Wewnętrznej'
})

export const INTERNAL_COMPLAINT_TABS = Object.freeze({
    DETAILS: 0,
    ATTACHMENTS: 1,
    CAUSES: 2,
    RECOMMENDATIONS: 3,
    EXECUTION: 4,
})

const RAW_TAB_ITEMS = Object.freeze([
    {
        label: 'Szczegóły',
        visible: true,
        disabled: false
    },
    {
        label: 'Załączniki',
        visible: true,
        disabled: false
    },
    {
        label: 'Przyczyny',
        visible: true,
        disabled: false,
    },
    {
        label: 'Zalecenia',
        visible: true,
        disabled: false
    },
    {
        label: 'Wykonanie',
        visible: true,
        disabled: false
    }
])

export const createTabItems = () => RAW_TAB_ITEMS.map(item => ({ ...item }))
